import { ThemeKeys } from 'teacher-ui-client/utils/themes'

/**
 * A set of themed class names for the management tables
 */
export const TABLE_THEMES = {
  [ThemeKeys.blue]: {
    controlsBg: 'bg-oceany-blue-150',
    headerBg: 'bg-oceany-blue-100',
    bodyRowBg: 'bg-white even:bg-oceany-blue-50 hover:bg-oceany-blue-100 divide-x divide-white',
    bodyRowBgEditing: 'bg-juicy-orange-100 divide-x divide-white',
  },
  [ThemeKeys.green]: {
    controlsBg: 'bg-ms-green-150',
    headerBg: 'bg-ms-green-100',
    bodyRowBg: 'bg-white even:bg-ms-green-50 hover:bg-ms-green-100 divide-x divide-white',
    bodyRowBgEditing: 'bg-juicy-orange-100 divide-x divide-white',
  },
  [ThemeKeys.darkBlue]: {
    controlsBg: 'bg-wl-blue-100',
    headerBg: 'bg-wl-blue-100',
    bodyRowBg: 'bg-white even:bg-wl-blue-50 hover:bg-wl-blue-100 divide-x divide-white',
    bodyRowBgEditing: 'bg-juicy-orange-100 divide-x divide-white',
  },
  [ThemeKeys.default]: {
    controlsBg: 'bg-dusty-black-150',
    headerBg: 'bg-dusty-black-100',
    bodyRowBg: 'bg-white even:bg-dusty-black-50 hover:bg-dusty-black-100 divide-x divide-white',
    bodyRowBgEditing: 'bg-juicy-orange-100 divide-x divide-white',
  },
}
